// extracted by mini-css-extract-plugin
module.exports = {"loaderLayer":"Loader_loaderLayer__3vjDP","big-to-small":"Loader_big-to-small__10wz3","small-to-big":"Loader_small-to-big__2Xh_3","loading-noku3":"Loader_loading-noku3__37fU6"};